@if (isEmbeddedCropFieldUnavailable()) {
  <agr-notification-empty [isEmpty]="true" />
} @else {
  <div
    [formGroup]="form"
    [class.content]="!disableCropFieldSelector()"
    [class.content-embedded]="disableCropFieldSelector()"
  >
    <div
      class="flex flex--row full-width flex--align-center header"
      [class.flex--justify-space-between]="!disableCropFieldSelector()"
      [class.flex--justify-end]="disableCropFieldSelector()"
    >
      @if (!disableCropFieldSelector()) {
        <div class="flex__child">
          <div class="custom-selector">
            <label class="placeholder" id="cropFieldSelectLabel" for="cropFieldSelect">{{
              'blightV2.shared.selectCropField' | translate
            }}</label>
            <div class="crop-field-select-sizer">
              <span class="crop-field-select-sizer__text" aria-hidden="true">{{ longestOptionText() }}</span>
              <mat-select
                formControlName="cropField"
                panelClass="disease-crop-field-select-panel"
                id="cropFieldSelect"
                aria-labelledby="cropFieldSelectLabel"
              >
                @for (cropField of cropFields(); track cropField.cropFieldId) {
                  <mat-option [value]="cropField.cropFieldId">{{ cropField.cropFieldName }}</mat-option>
                }
              </mat-select>
            </div>
          </div>
          @if (selectedCropFieldAdvice()?.cropVarietyName) {
            <span class="crop-variety-label"
              ><strong>{{ 'BFP.UI.Variety' | translate }}:</strong>
              {{ selectedCropFieldAdvice()?.cropVarietyName }}</span
            >
          }

          <button
            mat-flat-button
            color="accent"
            class="action-button"
            [matMenuTriggerFor]="blightMenu.menu"
            (menuOpened)="onHeaderActionMenuOpened()"
          >
            <mat-icon class="table-toolbar-button-icon action-button-icon">add_task</mat-icon>
            <span class="flex--align-center table-toolbar-button-span">
              {{ 'shared.diseaseTable.actions' | translate }}
              <mat-icon>keyboard_arrow_down</mat-icon>
            </span>
          </button>
        </div>
      }
      <div class="flex">
        <div class="flex--row">
          <app-recalculate-button
            (recalculate)="onRecalculate()"
            [disabled]="isRecalculationDisabled()"
            [disabledTooltip]="isCropYearReadOnly() ? ('UI.CurrentYearOnlyMutationMessage' | translate) : ''"
            [isLoading]="store.isBlightCropFieldsSyncing()"
            [label]="'shared.diseaseTable.recalculateAdviceInsight' | translate"
            [loadingLabel]="'blightV2.shared.recalculating' | translate"
          />
        </div>
        <div class="flex--row flex--align-center table-toolbar-button-group">
          <app-date-selector
            [minimalDate]="minimalDate()"
            [maximalDate]="maximalDate()"
            [selectedDates]="store.selectedDates()"
            (selectedDatesChanges)="onSelectedDatesChanged($event)"
          />
        </div>
      </div>
    </div>

    @if (store.selectedCropFieldId() && selectedCropField(); as cropField) {
      <div class="toolbar-container">
        <app-blight-details-toolbar
          [selectedCropField]="cropField"
          [hasBlightAdvices]="hasAdvices()"
          [isParticipatingToBem]="store.selectedCropFieldIsParticipatingToBem()"
          [isReadOnly]="isReadOnly()"
        />
      </div>
    }

    @if (store.selectedCropFieldId()) {
      <app-disease-insight-chart
        [selectedRange]="store.selectedDates()"
        [chartDays]="chartDays()"
        [advice]="adviceForChart()"
        [showDataWithoutAdvices]="showHarvestedNoAdvice()"
        [dateHeaderAccessoryTemplate]="dateHeaderAccessory"
        [riskTableRowsTemplate]="riskTableRows"
        (actionTriggered)="onActionTriggered($event)"
      />
    }
  </div>
}

<span
  #menuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="blightMenu.menu"
  style="position: fixed; visibility: hidden; pointer-events: none"
></span>
<app-blight-action-menu #blightMenu [advices]="selectedAdvice()" [actionDate]="actionDate()" />

<ng-template #dateHeaderAccessory let-day>
  @if (day.sprayEffectivity && day.sprayEffectivity < 1) {
    <div class="hover-text">
      <mat-icon class="text-color--warn-400" style="font-size: 22px">warning</mat-icon>
      <span class="tooltip-text right">{{ 'blight.blightChart.oosporeWarning' | translate }}</span>
    </div>
  }
</ng-template>

<ng-template #riskTableRows let-days let-chart="chart">
  <tr class="details-row">
    <td class="no-borders">
      <div class="hover-text">
        <img alt="" src="assets/icons/unprotected_leaf_layers.svg" />
        <span class="tooltip-text right">{{ 'blight.blightChart.unprotectedLeafLayers' | translate }}</span>
      </div>
    </td>
    @for (day of days; track day.date) {
      <td
        (mouseenter)="chart.showTooltip($event, getUnprotectedGrowthTooltip(day))"
        (mouseleave)="chart.hideTooltip()"
        [style.background-color]="chart.getUnprotectedGrowthBackground(day.unprotectedGrowth ?? 0)"
      ></td>
    }
  </tr>

  <tr class="details-row">
    <td class="no-borders">
      <div class="hover-text">
        <img alt="" src="assets/icons/tuber_infection_risk.svg" />
        <span class="tooltip-text right">{{ 'blight.blightChart.tuberInfectionRisk' | translate }}</span>
      </div>
    </td>
    @for (day of days; track day.date) {
      <td [ngClass]="chart.getTuberInfectionRiskBackground(day.tuberInfectionRisk ?? 0)"></td>
    }
  </tr>

  <tr class="details-row">
    <td class="no-borders">
      <div class="hover-text">
        <img alt="" src="assets/icons/oospore_formation.svg" />
        <span class="tooltip-text right">{{ 'blight.blightChart.oosporeFormation' | translate }}</span>
      </div>
    </td>
    @for (day of days; track day.date) {
      <td [ngClass]="chart.getOoSporesRiskBackground(day.ooSporesRisk ?? false)"></td>
    }
  </tr>
</ng-template>
